import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CreditCard } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { startTopup } from "../../api/wallet";
import { formatNumber } from "../../lib/format";

export const PackagePicker = ({ wallet }) => {
  const { t } = useTranslation();
  const [tokens, setTokens] = useState(wallet.packages[0]);
  const [busy, setBusy] = useState(false);
  const invalid = Number(tokens) < wallet.min_custom_tokens;

  const buy = async () => {
    setBusy(true);
    try {
      const res = await startTopup(Number(tokens));
      window.location.href = res.checkout_url;
    } catch {
      toast.error(t("errors.generic"));
      setBusy(false);
    }
  };

  return (
    <NeuCard data-testid="wallet-topup-card" className="animate-rise-in">
      <p className="label-xs">{t("wallet.buyTokens")}</p>

      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {wallet.packages.map((pack) => (
          <button
            key={pack}
            data-testid={`wallet-package-${pack}`}
            onClick={() => setTokens(pack)}
            className={`rounded-2xl border px-3 py-4 text-center transition-[box-shadow,color] duration-300 ${
              Number(tokens) === pack
                ? "border-primary/50 text-primary shadow-neu-in"
                : "border-border/60 shadow-neu-sm hover:text-primary"
            }`}
          >
            <span className="block font-mono text-lg font-bold">{formatNumber(pack)}</span>
            <span className="block text-[11px] text-muted-foreground">{t("wallet.tokensUnit")}</span>
          </button>
        ))}
      </div>

      <div className="mt-5 grid gap-3 sm:grid-cols-[1fr_auto] sm:items-end">
        <div>
          <p className="label-xs mb-1">{t("wallet.customAmount")}</p>
          <NeuInput
            data-testid="wallet-custom-tokens"
            type="number"
            min={wallet.min_custom_tokens}
            value={tokens}
            onChange={(e) => setTokens(e.target.value)}
          />
          <p className="mt-1 text-xs text-muted-foreground">
            {t("wallet.minTokens", { count: wallet.min_custom_tokens })}
          </p>
        </div>
        <NeuButton
          variant="primary"
          data-testid="wallet-buy-btn"
          disabled={busy || invalid}
          onClick={buy}
          className="flex items-center justify-center gap-2 py-4"
        >
          <CreditCard className="h-4 w-4" />
          {t("wallet.payTokens", { count: Number(tokens || 0) })}
        </NeuButton>
      </div>
    </NeuCard>
  );
};
